import { createContext, useState } from 'react'
import { getStoredFeatures, Features } from '../lib/localStorage'

export const FeatureFlags = createContext({} as Features);

export const FeatureFlagsProvider = ({ children }: any) => {
  const features = useState(getStoredFeatures())[0];

  return (
    <FeatureFlags.Provider value={features}>
      {children}
    </FeatureFlags.Provider>
  );
};
